import { useEffect } from 'react';
import { useHistory } from 'react-router';

import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useMyExpert from '@hooks/useMyExpert';
import { isNotNativeApp } from '@utils/platformUtils';
import { journeyRoute } from '@utils/routeUtils';

type Props = {
  journeyId: string;
};

const ExpertJourneyCommunityPage = ({ journeyId }: Props) => {
  const history = useHistory();
  const myExpert = useMyExpert();

  useEffect(() => {
    if (isNotNativeApp()) {
      window.location.href = 'https://gather.withgrayce.com/';
    } else {
      history.push(journeyRoute({ journeyId, linkAfterJourney: '/home', myExpert }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.community.show" journeyId={journeyId}>
      <></>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyCommunityPage;
